import { useEffect, useRef, useState } from "react";
import {
  AdditionalPage,
  Separator,
  Spinner,
  InputBox,
  ModalButton,
  PageBottom,
} from "../accessories/accessories";
import CustomText from "../accessories/CustomText";
import {
  BackHandler,
  Dimensions,
  FlatList,
  Linking,
  Modal,
  ScrollView,
  StyleSheet,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import {
  FormatPhoneLogin,
  getInitials,
  handleAPI,
  sortByKey,
} from "../accessories/CommonFunctions";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import EvilIcons from "react-native-vector-icons/EvilIcons";
import Feather from "react-native-vector-icons/Feather";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import Entypo from "react-native-vector-icons/Entypo";
import Footer from "../accessories/footer";
import { android, ios, web } from "../accessories/Platform";
import { updateWebURL } from "../accessories/CommonFunctions";
import * as Contacts from "expo-contacts";
import FontAwesome from "react-native-vector-icons/FontAwesome";
import ScrollContainer from "../accessories/ScrollContainer";

const LoanContacts = (props) => {
  const { UserId = 0, LoanId, From, SessionId } = props.route.params;

  const { navigation } = props;
  const [searchValue, setSearchValue] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);

  const loanContact = [],
    scrollViewRef = useRef(null),
    width = web ? 700 : Dimensions.get("window").width - 30;

  const [TabDetails, setTabDetails] = useState([]);
  const [ContactData, setContactData] = useState([]);
  const [LoanContactDetails, setLoanContactDetails] = useState(null);
  const [ProspectDetails, setProspectDetails] = useState([]);
  const [PhoneContacts, setPhoneContacts] = useState([]);
  const [LeadDetails, setLeadDetails] = useState([]);
  const [PageView, setPageView] = useState([]);
  const [AllLoanContactDetails, setAllLoanContactDetails] =
    useState(loanContact);
  const isMobileWeb = Dimensions.get("window").width <= 480;
  const [newContactDetails, setNewContactDetails] = useState({
    firstName: "",
    lastName: "",
    cell: "",
    phone: "",
    email: "",
  });

  const handleContactDetails = (name, value) => {
    setNewContactDetails({ ...newContactDetails, [name]: value });
  };
  const groupByKey = (input, key) => {
    let data = input.reduce((acc, currentValue) => {
      let groupKey = currentValue[key];
      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }
      acc[groupKey].push(currentValue);
      return acc;
    }, {});

    return data;
  };

  const handleGetContactWithInitial = () => {
    const contacts = sortByKey(
      LoanContactDetails[TabDetails[activeIndex]?.Name] || [],
      "Name"
    );
    if (activeIndex == 0) return contacts;

    const groupedContacts = contacts.reduce((acc, contact) => {
      const firstLetter = contact.Name.charAt(0).toUpperCase();
      if (!acc[firstLetter]) {
        acc[firstLetter] = [];
      }
      acc[firstLetter].push(contact);
      return acc;
    }, {});

    return Object.entries(groupedContacts).flatMap(([letter, contacts]) => [
      { title: letter, isInitial: true },
      ...contacts,
    ]);
  };

  useEffect(() => {
    scrollViewRef?.current?.scrollTo({
      animated: true,
      x: (web ? 700 : Dimensions.get("window").width - 30) * activeIndex,
      y: 0,
    });
  }, [activeIndex]);

  const AccessPhoneContacts = async () => {
    const { status } = await Contacts.requestPermissionsAsync();
    if (status === "granted") {
      const { data } = await Contacts.getContactsAsync();

      let phoneContacts =
        (data || [])
          .filter(({ name }) => !name.includes("null"))
          .map((contact) => {
            let phoneNumberList = contact?.phoneNumbers || [],
              Cell = "",
              Phone = "",
              Name = contact.name,
              EmailList = contact?.emails || [],
              Email = "";
            if (EmailList.length) {
              EmailList = EmailList.map((emails) => emails.email).map(
                (email) => email
              );
              if (EmailList.length) Email = EmailList[0];
            }
            phoneNumberList.forEach((phone) => {
              if (phone.label === "mobile") Cell = phone.number;
              if (phone.label === "home") Phone = phone.number;
            });

            if (Name) {
              return {
                title: "Contact",
                TabName: "Contacts",
                Name,
                Phone,
                Cell,
                Email,
              };
            }
            return null;
          })
          .filter(Boolean) || [];

      return phoneContacts || [];
    }
  };

  const [modalContactDetails, setModalContactDetails] = useState({
    isShow: false,
  });
  const [modalAddContact, setModalAddContact] = useState({
    isShow: false,
  });

  const navigate = (path, option) => {
    updateWebURL({ ...option, Path: path });
    (navigation || props["navigation"]).navigate(path, option || {});
  };

  const AddContactDetails = async () => {
    try {
      let { firstName, lastName, cell, phone, email } = newContactDetails;

      const contact = {
        [Contacts.Fields.FirstName]: firstName,
        [Contacts.Fields.LastName]: lastName,
        [Contacts.Fields.PhoneNumbers]: [
          {
            label: "mobile",
            number: cell,
          },
          {
            label: "home",
            number: phone,
          },
        ],
        [Contacts.Fields.Emails]: [{ label: "work", email: email }],
      };

      const { status } = await Contacts.requestPermissionsAsync();
      if (status === "granted") {
        const contactId = await Contacts.addContactAsync(contact);
        setTimeout(() => {
          handleGetPhoneContact();
          setModalAddContact({
            isShow: false,
          });
        }, 500);
      }
    } catch (error) {
      console.error("Error form addContactAsync", error);
    }
  };

  const handleBackAction = () => {
    if (web) {
      props?.setFloatPage(null);
    } else {
      navigation.navigate(From || "DashBoard");
    }
  };

  useEffect(() => {
    setLoanContactDetails(AllLoanContactDetails);
  }, [AllLoanContactDetails]);

  const handleGetPhoneContact = async () => {
    let iPhoneContacts = PhoneContacts || [];
    if (iPhoneContacts.length == 0) {
      iPhoneContacts = await AccessPhoneContacts();
      // setPhoneContacts(iPhoneContacts);
      setAllLoanContactDetails((prevContact) => {
        return {
          ...prevContact,
          Contacts: iPhoneContacts,
        };
      });

      setTabDetails((prevTabDetails) => {
        let iTabDetails = prevTabDetails.length ? prevTabDetails : TabDetails;
        return iTabDetails.map((item) => {
          if (item["Name"] === "Contacts")
            item["count"] = iPhoneContacts?.length || 0;
          return item;
        });
      });
    }
  };
  useEffect(() => {
    handleGetPhoneContact();
    handleAPI({
      name: "GetNewLoanAppContacts",
      params: {
        SessionId: SessionId,
      },
    })
      .then((contactData) => {
        contactData = JSON.parse(contactData).Table;

        setContactData(contactData);

        contactData = groupByKey(contactData, "TabName");

        const distinctNames = Object.keys(contactData).map((key) => {
          return {
            Name: key,
            count: contactData[key]?.length || 0,
          };
        });

        !web &&
          distinctNames.push({
            Name: "Contacts",
            count: 0,
          });

        setTabDetails((prevTabDetails) => {
          return distinctNames.map((item, index) => {
            if (item["Name"] === "Contacts")
              item["count"] = prevTabDetails[index]?.count || 0;
            return item;
          });
        });
        // setLoanContactDetails(contactData["Loan Contacts"] || []);
        // setProspectDetails(contactData["Prospects"] || []);
        // setLeadDetails(contactData["Leads"] || []);
        setActiveIndex(0);
        setAllLoanContactDetails((prevContact) => {
          return {
            ...prevContact,
            ...contactData,
          };
        });
      })
      .catch((error) =>
        console.error("Error form GetLoanContacts =====> ", error)
      );

    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      handleBackAction
    );
    return () => backHandler.remove();
  }, []);

  const handleSearchContact = (value) => {
    const matchingArrays = {};

    for (const key in AllLoanContactDetails) {
      const matchedEntries = AllLoanContactDetails[key].filter((entry) =>
        Object.values(entry).some((val) =>
          val?.toString()?.toLowerCase()?.includes(value?.toLowerCase())
        )
      );
      if (matchedEntries.length > 0) {
        matchingArrays[key] = matchedEntries;
      }
    }

    return Object.keys(matchingArrays).length > 0 ? matchingArrays : null;
  };
  useEffect(() => {
    let filteredData = searchValue?.toString().trim()
      ? handleSearchContact(searchValue?.toString().trim())
      : AllLoanContactDetails;
    setLoanContactDetails(filteredData);
  }, [searchValue]);

  const formatPhoneNumber = (Type) => {
    handleContactDetails(Type, FormatPhoneLogin(newContactDetails[Type] || ""));
  };

  const RenderItem = ({ item: contact, index }) => {
    let { title, Name, Phone, Cell, Email, isInitial = false } = contact;

    return (
      <>
        {isInitial && (
          <View key={index}>
            <CustomText
              style={{
                paddingHorizontal: 10,
                backgroundColor: "#f5f5f5",
                fontSize: 16,
                paddingVertical: 5,
              }}
              bold={true}
            >
              {title}
            </CustomText>
          </View>
        )}
        {activeIndex == 0 && (
          <View key={index}>
            <CustomText
              style={{
                paddingHorizontal: 10,
                backgroundColor: "#f5f5f5",
                fontSize: 16,
                paddingVertical: 5,
              }}
              bold={true}
            >
              {title}
            </CustomText>
          </View>
        )}
        {!isInitial && (
          <View style={{ flexDirection: "row", paddingVertical: 10 }}>
            <TouchableOpacity
              activeOpacity={1}
              style={{ flexDirection: "row", flex: 1 }}
              onPress={() => {
                setModalContactDetails({
                  ...{
                    isShow: true,
                    Title: title,
                  },
                  ...{ Name, Phone, Cell: Cell || Phone, Email },
                });
              }}
            >
              <View
                style={{
                  borderRadius: 50,
                  backgroundColor: "#295b9a",
                  marginRight: 10,
                  minWidth: 40,
                  maxWidth: 40,
                  minHeight: 40,
                  maxHeight: 40,
                  justifyContent: "center",
                }}
              >
                <CustomText style={{ color: "#fff", alignSelf: "center" }}>
                  {getInitials(Name || "")}
                </CustomText>
              </View>
              <View>
                <CustomText style={{ fontSize: 17 }}>{Name}</CustomText>

                <CustomText style={{ fontSize: 12 }}>
                  {FormatPhoneLogin(Phone || Cell || "")}
                </CustomText>
              </View>
              <EvilIcons
                name="chevron-right"
                size={30}
                style={{
                  position: "absolute",
                  alignSelf: "center",
                  right: 10,
                }}
              />
            </TouchableOpacity>
          </View>
        )}
        {/* {index ==
          (LoanContactDetails[TabDetails[activeIndex]?.Name] || []).length -
            1 && (
          <>
            <View style={{ marginTop: 15, marginBottom: 150 }}>
              <PageBottom />
            </View>
          </>
        )} */}
      </>
    );
  };

  const handleSliderPage = (event) => {
    const { x } = event.nativeEvent.contentOffset,
      indexOfNextScreen = Math.round(x / width);
    setActiveIndex(indexOfNextScreen);
    // setIndex(indexOfNextScreen);
  };

  return (
    <>
      <AdditionalPage
        title="Contacts"
        handleBack={handleBackAction}
        isClose={web}
        rightContent={
          <View style={{ marginRight: 3 }}>
            <MaterialIcons
              name="person-add-alt-1"
              size={25}
              onPress={() => {
                setModalAddContact({
                  ...{
                    isShow: true,
                    Title: "Add Contacts",
                  },
                });
              }}
            />
          </View>
        }
      >
        <View
          style={{
            paddingHorizontal: 15,
          }}
        >
          <View
            style={{
              borderBottomColor: "black",
              borderBottomWidth: 1,
              flexDirection: "row",
            }}
          >
            <EvilIcons
              name="search"
              size={25}
              color="#999"
              style={{ alignSelf: "center", marginTop: android ? -5 : 0 }}
            />
            <TextInput
              style={{
                padding: 5,
                height: 34,
                // color: "#999",
                fontFamily: web
                  ? `"Helvetica Neue",Helvetica,Arial,sans-serif`
                  : "Regular",
                flex: 1,
              }}
              placeholder="Search Contacts"
              value={searchValue || ""}
              onChangeText={(text) => {
                setSearchValue(text);
              }}
            />
            {searchValue && (
              <FontAwesome
                name="close"
                size={15}
                color="red"
                onPress={() => setSearchValue("")}
                style={{ alignSelf: "center", marginRight: 10 }}
              />
            )}
          </View>
          {LoanContactDetails == null ? (
            <View style={{ paddingVertical: 20 }}>
              <CustomText
                style={{ fontSize: 16, marginBottom: 25, alignSelf: "center" }}
                bold={true}
              >
                No Contact Found!
              </CustomText>
              <PageBottom />
            </View>
          ) : Object.keys(LoanContactDetails || {}).length === 0 ? (
            <View style={{ paddingVertical: 20 }}>
              <Spinner />
            </View>
          ) : (
            <></>
          )}
          <View style={{ flexDirection: "row", paddingVertical: 15 }}>
            <ScrollView horizontal showsHorizontalScrollIndicator={false}>
              {LoanContactDetails != null && (
                <>
                  {TabDetails.map((tabDetails, index) => {
                    let { Name, count } = tabDetails;
                    count = (LoanContactDetails || {})[Name]?.length || 0;
                    return (
                      <TouchableOpacity
                        key={index}
                        activeOpacity={0.5}
                        style={{
                          paddingHorizontal: 15,
                          marginHorizontal: 5,
                          paddingVertical: 10,
                          borderBottomWidth: 1,
                          borderBottomColor:
                            activeIndex === index ? "#295b9a" : "black",
                        }}
                        onPress={() => {
                          // setSearchValue("");
                          setActiveIndex(index);
                        }}
                      >
                        <CustomText
                          style={{
                            color: activeIndex === index ? "#295b9a" : "",
                          }}
                          bold={true}
                        >
                          {`${Name} ${count ? `(${count})` : ""}`}
                        </CustomText>
                      </TouchableOpacity>
                    );
                  })}
                </>
              )}
            </ScrollView>
          </View>
          {Object.keys(LoanContactDetails || {}).length > 0 ? (
            <>
              {LoanContactDetails[TabDetails[activeIndex]?.Name]?.length > 0 ? (
                <ScrollContainer showScrollBar={false}>
                  <FlatList
                    showsVerticalScrollIndicator={false}
                    style={
                      ios && {
                        flex: 1,
                        height: Dimensions.get("window").height - 305,
                      }
                    }
                    data={handleGetContactWithInitial()}
                    keyExtractor={(item, index) => {
                      return index.toString();
                    }}
                    renderItem={RenderItem}
                    onEndReachedThreshold={0.1}
                    ListFooterComponent={
                      <View style={{ marginTop: 15, marginBottom: 150 }}>
                        <PageBottom />
                      </View>
                    }
                  />
                </ScrollContainer>
              ) : searchValue ? (
                <View style={{ paddingVertical: 20 }}>
                  <CustomText
                    style={{
                      fontSize: 16,
                      marginBottom: 25,
                      alignSelf: "center",
                    }}
                    bold={true}
                  >
                    {`No ${TabDetails[activeIndex]?.Name || "Contact"} Found!`}
                  </CustomText>
                  <PageBottom />
                </View>
              ) : (
                <View style={{ paddingVertical: 20 }}>
                  <Spinner />
                </View>
              )}
            </>
          ) : (
            <></>
          )}
        </View>
      </AdditionalPage>
      <Modal
        visible={modalContactDetails["isShow"]}
        transparent
        animationType="slide"
      >
        <TouchableOpacity
          activeOpacity={1}
          style={[
            {
              height: "100%",
              flex: 1,
              backgroundColor: "#535252a3",
            },
            web
              ? {
                  width:
                    props["from"] == "DashBoard"
                      ? 750
                      : isMobileWeb
                      ? "100%"
                      : 422,
                  left: isMobileWeb
                    ? 0
                    : 369 - (props["from"] == "DashBoard" ? 15 : 0),
                  bottom: 0,
                  position: "absolute",
                  height: "calc(100% - 86px)",
                }
              : {},
          ]}
          onPress={() => {
            setModalContactDetails({ isShow: false });
          }}
        ></TouchableOpacity>
        <View
          style={[
            {
              backgroundColor: "#fff",
              zIndex: 111,
              width: "100%",
              borderColor: "#d3dadf",
              borderWidth: 2,
              borderRadius: 5,
              boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)",
              alignSelf: "flex-end",
              justifyContent: "flex-end",
              position: "absolute",
              bottom: 0,
            },
            // web ? { width: isMobileWeb ? "100%" : 750 } : {},
          ]}
        >
          <View
            style={
              web
                ? {
                    width:
                      props["from"] == "DashBoard"
                        ? 750
                        : isMobileWeb
                        ? "100%"
                        : 419,
                    position: "absolute",
                    backgroundColor: "#fff",
                    left: isMobileWeb
                      ? 0
                      : 369 - (props["from"] == "DashBoard" ? 15 : 0),
                  }
                : {}
            }
          >
            <TouchableOpacity
              style={{ alignItems: "center", backgroundColor: "#f5f5f5" }}
              activeOpacity={1}
              onPress={() => {
                setModalContactDetails({ isShow: false });
              }}
            >
              <EvilIcons name="chevron-down" size={45} />
            </TouchableOpacity>
            <View
              style={{
                paddingHorizontal: 20,
                paddingVertical: 10,
                borderBottomWidth: 1.5,
                borderBottomColor: "#f5f5f5",
              }}
            >
              <CustomText style={[{ fontSize: 17, color: "black" }]}>
                {modalContactDetails["Name"]}
              </CustomText>
              <CustomText style={[{ fontSize: 13, color: "#999" }]}>
                {modalContactDetails["Title"]}
              </CustomText>
            </View>
            {/* {TabDetails[activeIndex]?.Name != "Contacts" && (
              <View style={[styles.modalRow]}>
                <MaterialIcons
                  name="person-outline"
                  size={25}
                  color="#999999"
                  style={styles.modalIcon}
                />
                <View style={{ flexDirection: "row" }}>
                  <CustomText style={[styles.modalTitle]}>
                    SERVICER:{" "}
                  </CustomText>
                  <CustomText style={[styles.modalTitle]}>
                    {modalContactDetails["Name"]?.toUpperCase()}
                  </CustomText>
                </View>
              </View>
            )} */}
            <View style={styles.modalRow}>
              <Feather
                name="phone"
                size={20}
                color="#999999"
                style={styles.modalIcon}
              />
              <TouchableOpacity
                activeOpacity={1}
                style={{ flex: 1 }}
                onPress={() => {
                  let phoneNumber = modalContactDetails["Cell"]
                    ?.replaceAll("-", "")
                    .replaceAll("(", "")
                    .replaceAll(")", "")
                    .replaceAll(" ", "");

                  phoneNumber = `tel://${phoneNumber}`;
                  Linking.canOpenURL(phoneNumber)
                    .then((supported) => {
                      if (!supported) {
                        console.log("Phone number is not available");
                      } else {
                        return Linking.openURL(phoneNumber);
                      }
                    })
                    .catch((err) => console.log(err));
                }}
              >
                <CustomText style={[styles.modalTitle]}>CALL</CustomText>
                {modalContactDetails["Cell"] && (
                  <CustomText style={[styles.modalContent]}>
                    {FormatPhoneLogin(modalContactDetails["Cell"] || "")}
                  </CustomText>
                )}
              </TouchableOpacity>
            </View>
            <View style={styles.modalRow}>
              <MaterialCommunityIcons
                name="email-outline"
                size={25}
                color="#999999"
                style={styles.modalIcon}
              />
              <TouchableOpacity
                style={{ flex: 1 }}
                activeOpacity={1}
                onPress={() => {
                  let subject = "",
                    body = "";

                  const emailUrl = `mailto:${
                    modalContactDetails["Email"]
                  }?subject=${encodeURIComponent(
                    subject
                  )}&body=${encodeURIComponent(body)}`;
                  modalContactDetails["Email"] && Linking.openURL(emailUrl);
                }}
              >
                <CustomText style={[styles.modalTitle]}>EMAIL</CustomText>
                {modalContactDetails["Email"] && (
                  <CustomText style={[styles.modalContent]}>
                    {modalContactDetails["Email"]}
                  </CustomText>
                )}
              </TouchableOpacity>
            </View>

            <View style={styles.modalRow}>
              <Entypo
                name="export"
                size={22}
                color="#999999"
                style={[styles.modalIcon, { marginTop: -35 }]}
              />
              <TouchableOpacity
                onPress={async () => {
                  let phoneNumber = modalContactDetails["Cell"]
                    ?.replaceAll("-", "")
                    .replaceAll("(", "")
                    .replaceAll(")", "")
                    .replaceAll(" ", "");

                  phoneNumber = `sms:${phoneNumber}`;

                  modalContactDetails["Cell"] &&
                    Linking.canOpenURL(phoneNumber)
                      .then((supported) => {
                        if (!supported) {
                          console.log("Phone number is not available");
                        } else {
                          return Linking.openURL(phoneNumber);
                        }
                      })
                      .catch((err) => console.log(err));
                }}
                style={{ flexDirection: "row" }}
              >
                <CustomText style={[styles.modalTitle]}>Send a Text</CustomText>
              </TouchableOpacity>
              <View style={{ height: 60 }}></View>
            </View>
          </View>
        </View>
      </Modal>
      <Modal
        visible={modalAddContact["isShow"]}
        transparent
        animationType="slide"
      >
        <TouchableOpacity
          activeOpacity={1}
          style={[
            {
              height: "100%",
              flex: 1,
              backgroundColor: "#535252a3",
            },
            web
              ? {
                  width:
                    props["from"] == "DashBoard"
                      ? 750
                      : isMobileWeb
                      ? "100%"
                      : 422,
                  left: isMobileWeb
                    ? 0
                    : 369 - (props["from"] == "DashBoard" ? 15 : 0),
                  bottom: 0,
                  position: "absolute",
                  height: "calc(100% - 86px)",
                }
              : {},
          ]}
          onPress={() => {
            setModalAddContact({ isShow: false });
          }}
        ></TouchableOpacity>
        <View
          style={[
            {
              backgroundColor: "#fff",
              zIndex: 111,
              width: "100%",
              borderColor: "#d3dadf",
              borderWidth: 2,
              borderRadius: 5,
              boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)",
              alignSelf: "flex-end",
              justifyContent: "flex-end",
              position: "absolute",
              bottom: 0,
            },
            web
              ? {
                  width: isMobileWeb
                    ? "100%"
                    : props["from"] == "DashBoard"
                    ? 750
                    : 419,
                  position: "absolute",
                  backgroundColor: "#fff",
                  left: isMobileWeb
                    ? 0
                    : 369 - (props["from"] == "DashBoard" ? 15 : 0),
                }
              : {},
          ]}
        >
          <View>
            <TouchableOpacity
              style={{ alignItems: "center", backgroundColor: "#f5f5f5" }}
              activeOpacity={1}
              onPress={() => {
                setModalAddContact({ isShow: false });
              }}
            >
              <EvilIcons name="chevron-down" size={45} />
            </TouchableOpacity>
            <View
              style={{
                paddingHorizontal: 20,
                paddingVertical: 10,
                borderBottomWidth: 1.5,
                borderBottomColor: "#f5f5f5",
                alignItems: "center",
              }}
            >
              <CustomText style={{ fontSize: 18 }} bold={true}>
                {modalAddContact["Title"]}
              </CustomText>
            </View>

            <View style={[styles.modalColumn]}>
              <View style={{ flexDirection: "row", paddingBottom: 1 }}>
                <InputBox
                  label="First Name"
                  placeholder="Enter First Name"
                  onChangeText={(text) => {
                    handleContactDetails("firstName", text);
                  }}
                />
              </View>

              <View style={{ flexDirection: "row", paddingBottom: 1 }}>
                <InputBox
                  label="Last Name"
                  placeholder="Enter Last Name"
                  onChangeText={(text) => {
                    handleContactDetails("lastName", text);
                  }}
                />
              </View>
              <View style={{ flexDirection: "row" }}>
                <InputBox
                  keyboardType="numeric"
                  label="Cell Phone"
                  placeholder="Enter Cell Phone"
                  value={newContactDetails["cell"]}
                  onBlur={() => {
                    formatPhoneNumber("cell");
                  }}
                  onChangeText={(text) => {
                    handleContactDetails("cell", text);
                  }}
                />
              </View>
              <View style={{ flexDirection: "row" }}>
                <InputBox
                  keyboardType="numeric"
                  label="Home Phone"
                  placeholder="Enter Home Phone"
                  value={newContactDetails["phone"]}
                  onBlur={() => {
                    formatPhoneNumber("phone");
                  }}
                  onChangeText={(text) => {
                    handleContactDetails("phone", text);
                  }}
                />
              </View>
              <View style={{ flexDirection: "row" }}>
                <InputBox
                  label="Email Address"
                  placeholder="Enter Email Address"
                  onChangeText={(text) => {
                    handleContactDetails("email", text);
                  }}
                />
              </View>
              <View
                style={{
                  flexDirection: "row",
                  alignSelf: "flex-end",
                }}
              >
                <ModalButton
                  //disabled={showSpinner}
                  onPress={(e) => {
                    AddContactDetails();
                  }}
                  title="Add Contact"
                />
              </View>
              <Separator />
            </View>
          </View>
        </View>
      </Modal>
      {/* <View
        style={[
          {
            backgroundColor: "#fff",
            flexDirection: "row",
            position: "absolute",
            bottom: 50,
            paddingVertical: 10,
          },
          web && {
            paddingTop: 10,
            width: currentPage === pageArray[pageId["eSign"]] ? 880 : 425,
            marginLeft: 20,
            position: "fixed",
            borderTopWidth: 2,
            borderTopColor: "#ccc",
          },
        ]}
      >
        {<RenderFooter />}
      </View> */}
      {!web && (
        <Footer
          iLoanId={LoanId}
          navigate={navigate}
          From="DashBoard"
          UserId={UserId}
        />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  modalRow: {
    paddingHorizontal: 20,
    paddingVertical: 13,
    borderBottomWidth: 1.5,
    borderBottomColor: "#f5f5f5",
    flexDirection: "row",
  },
  modalColumn: {
    paddingHorizontal: 20,
    paddingVertical: 13,
    borderBottomWidth: 1.5,
    borderBottomColor: "#f5f5f5",
    flexDirection: "column",
  },
  modalTitle: {
    color: "black",
    letterSpacing: 1.5,
    fontSize: 15,
    marginBottom: 2,
  },
  modalContent: {
    fontSize: 13,
  },
  modalIcon: {
    marginRight: 10,
    alignSelf: "center",
  },
});

export default LoanContacts;
